// import ModalAddTeacherClass from "./modalAddTeacherClass/modalAddTeacherClass";
import ModalEditTeacherClass from "../editTeacherClass/editTeacherClass";
import React, { useEffect, useState, useRef } from "react";
import './GroupsList.scss'
import TableCstm from '../../../TableCstm/TableCstm';
import Select from '../../../select/select';
import { GetSubsidiaryList, GetAllTeacherClassesBySubsidiary } from "../../../../utils/Apis/apis";
import Button from "../../../button/button";
import Tooltip from "../../../Tooltip/Tooltip";
import ConfirmModal from "../../../ConfirmModalV3/confirmModal";
import { EditUnitTeacherClasses, GetUnitLimitsGroup } from "../../../../utils/Apis/principalApis";
import { dateFormatDDMMAAAA, getLocalDateObject } from "../../../../utils/dateTimeZone";
const GroupsList = ({ user, showAlert }) => {
    //LIST 

    const [subsidiaryList, setSubsidiaryList] = useState([])
    // Options for sorting the groups by different criteria
    const selectOptions = [
        { label: 'Salón', value: 'classroom' },
        { label: 'Maestro', value: 'teacher' },
        { label: 'Nivel', value: 'book' },
        { label: 'Horario', value: 'schedule' },
        { label: 'Tipo de clase', value: 'typeLesson' },
    ];
    const selectOptionsStatus = [
        { label: 'En curso', value: '1' },
        { label: 'Proximamente', value: '2' },
        { label: 'Finalizado', value: '3' },
        { label: 'Eliminados', value: '4' },
    ];

    const modalityOptions = [
        { label: 'Todas', value: '1' },
        { label: 'Prescencial', value: '2' },
        { label: 'Online', value: '3' }
    ];

    const [sortCriteria, setSortCriteria] = useState('teacher'); // State for tracking selected sorting criteria
    const [sortSubsidiaryCriteria, setSortSubsidiaryCriteria] = useState(`${user.fk_subsidiary}`); // State for tracking selected sorting criteria
    const [sortStatusCriteria, setSortStatusCriteria] = useState('1'); // State for tracking selected sorting criteria
    const [selectedModality, setSelectedModality] = useState('1')
    const [arrayTeacherClasses, setArrayTeacherClasses] = useState([])
    const [filteredArrayTeacherClasses, setFilteredArrayTeacherClass] = useState([]);
    const [selectedItemRow, setSelectedItemRow] = useState({})
    const [openModalEditTeacher, setOpenModalEditTeacher] = useState(false)
    const [openConfirmUpdateUnit, setOpenConfirmUpdateUnit] = useState(false)

    const [disabledButtonConfirmModal, setDisabledButtonConfirmModal] = useState(false)
    const cacheGroupList = useRef({});
    const [modalConfirmTitle, setModalConfirmTitle] = useState('')
    const [modalConfirmDescription, setModalConfirmDescription] = useState('')
    useEffect(() => {
        fetchTeacherClassData()
    }, [sortSubsidiaryCriteria]);

    const fetchTeacherClassData = async (forceUpdate = false) => {
        try {

            if (forceUpdate) {
                // Invalida el caché para esta sucursal
                delete cacheGroupList.current[sortSubsidiaryCriteria];
            }
            if (!forceUpdate) {
                const cached = cacheGroupList.current[sortSubsidiaryCriteria];
                if (cached) {
                    setArrayTeacherClasses(cached.teacherClasses);
                    setSubsidiaryList(cached.subsidiaryList);
                    return;
                }
            }

            const [teacherClassesBySubsidiaryResponse, subsidiaryResponse] = await Promise.all([
                GetAllTeacherClassesBySubsidiary(sortSubsidiaryCriteria),
                GetSubsidiaryList(),
            ]);

            if (
                teacherClassesBySubsidiaryResponse.auth === false ||
                subsidiaryResponse.auth === false
            ) {
                window.location.reload();
                return;
            }

            const formattedSubsidiaryList = subsidiaryResponse.result.map(element => ({
                value: element.id,
                label: element.name,
                classrooms: element.classrooms
            }));

            // Guardar en caché (solo si no es forceUpdate)
            if (!forceUpdate) {
                cacheGroupList.current[sortSubsidiaryCriteria] = {
                    teacherClasses: teacherClassesBySubsidiaryResponse.teacherClasses,
                    subsidiaryList: formattedSubsidiaryList,
                };
            }

            setArrayTeacherClasses(teacherClassesBySubsidiaryResponse.teacherClasses);
            setSubsidiaryList(formattedSubsidiaryList);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        applyFilters(sortSubsidiaryCriteria, sortStatusCriteria, selectedModality)
    }, [arrayTeacherClasses])

    const criteriaOptions = {
        classroom: {
            header: 'Classroom',
            columns: [
                { header: "ID Grupo", accessor: "id_group", className: "tableCtype2 td" },
                { header: "Horario", accessor: "schedule", className: "tableCtype5 td" },
                { header: "Fecha de inicio", accessor: "dateStart", className: "tableCtype2 td" },
                { header: "Fecha de finalizacion", accessor: "dateEnd", className: "tableCtype2 td" },
                { header: "Maestro", accessor: "teacher", className: "tableCtype5 td" },
                { header: "Nivel", accessor: "book", className: "tableCtype2 td" },
                { header: "Unidad", accessor: "unit", className: "tableCtype2 td" },
                { header: "Estudiantes", accessor: "students_qty", className: "tableCtype1 td" },
                { header: "Plantel", accessor: "subsidiary", className: "tableCtype2 td" },
                { header: "Tipo de clase", accessor: "typeLesson", className: "tableCtype4 td" },
                { header: "Online", accessor: "isOnline", className: "tableCtype1 td" },
                { header: "Promoción", accessor: "promotion", className: "tableCtype3 td" },

            ],
            // Content for classroom section header
            sectionContent: (classroom) => (
                <div className='section-content'>
                    <h1>{classroom.name}</h1>
                    {classroom.id &&
                        <span>Capacidad: {classroom.capacity || 'Unknown'}</span>
                    }
                </div>
            ),
            // Data mapping for classroom sorting
            dataAccessor: (group) => ({
                id_group: group.id,
                id_filter: group.classroom.id,
                name: group.classroom.name || 'HORARIO DISPONIBLE',
                capacity: group.classroom.capacity || 'Unknown',
                schedule: group?.full_dayclass ? formatFullDayClass(group.full_dayclass) : 'Unknown',
                teacher: group.teacher.name || 'Maestro no asignado',
                book: group.level.name || 'HORARIO',
                unit: group.level?.unitName
                    ? group.level.unitPart
                        ? `${group.level.unitName} ${group.level.unitPart}`
                        : group.level.unitName
                    : 'DISPONIBLE',
                students_qty: `${group.students_qty || '0'}/${group.classroom?.capacity || 'Salon no especificado'}` || `0/${group.classroom?.capacity || 'Salon no especificado'}`,
                subsidiary: group.subsidiary.name || 'Unknown',
                typeLesson: group.type_class?.name || 'Unknown',
                isOnline: group.is_online ? 'SI' : 'NO' || 'Unknown',
                promotion: group.promotion?.code || 'No tiene promocion',
                date: {
                    start: group.date?.start || 'No especificado',
                    end: group.date?.end || 'No especificado'
                },
                dateStart: group.date?.start
                    ? dateFormatDDMMAAAA(group.date.start)
                    : "No especificado",
                dateEnd: group.date?.end ? dateFormatDDMMAAAA(group.date.end)
                    : "No especificado",
                observation: group.observation || ''

            })
        },
        // Similar configuration for 'teacher' sorting
        teacher: {
            header: 'Teacher',
            columns: [
                { header: "ID Grupo", accessor: "id_group", className: "tableCtype2 td" },
                { header: "Horario", accessor: "schedule", className: "tableCtype5 td" },
                { header: "Fecha de inicio", accessor: "dateStart", className: "tableCtype2 td" },
                { header: "Fecha de finalizacion", accessor: "dateEnd", className: "tableCtype2 td" },
                { header: "Nivel", accessor: "book", className: "tableCtype2 td" },
                { header: "Unidad", accessor: "unit", className: "tableCtype2 td" },
                { header: "Estudiantes", accessor: "students_qty", className: "tableCtype1 td" },
                { header: "Salón", accessor: "classroom", className: "tableCtype2 td" },
                { header: "Plantel", accessor: "subsidiary", className: "tableCtype2 td" },
                { header: "Tipo de clase", accessor: "typeLesson", className: "tableCtype4 td" },
                { header: "Online", accessor: "isOnline", className: "tableCtype1 td" },
                { header: "Promoción", accessor: "promotion", className: "tableCtype3 td" },

            ],
            sectionContent: (teacher) => (
        <div className="section-content">
          <h1>{teacher.name || "Maestro no asignado"}</h1>

          <span>Correo electrónico: {teacher.email || "Unknown"}</span>
          <br />

          <span>Teléfono: {teacher.phoneNumber || "Unknown"}</span>
          <br />
          <span>Recepcionistas: </span>
          {teacher.receptionist_in_charge.length === 0 ? (
            <strong>No cuenta con recepcionista encargado</strong>
          ) : (
            <div className="receptionist-list">
              {teacher.receptionist_in_charge.map((r) => (
                <div key={r.id} className="receptionist-item">
                  <strong>{r.name}</strong>
                  <span>{r.contact.phoneNumber}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      ),
            dataAccessor: (group) => ({
                id_group: group.id,
                id_filter: group.teacher.id ?? 'unassigned',
                name: group.teacher.name || 'Maestro no asignado',
                email: group.teacher.email || 'Unknown',
                phoneNumber: group.teacher.phoneNumber || 'Unknown',
                schedule: group?.full_dayclass ? formatFullDayClass(group.full_dayclass) : 'Unknown',
                classroom: group.classroom.name || 'No especificado',
                book: group.level.name || 'HORARIO',
                unit: group.level?.unitName
                    ? group.level.unitPart
                        ? `${group.level.unitName} ${group.level.unitPart}`
                        : group.level.unitName
                    : 'DISPONIBLE',
                students_qty: `${group.students_qty || '0'}/${group.classroom?.capacity || 'Salon no especificado'}` || `0/${group.classroom?.capacity || 'Salon no especificado'}`,
                subsidiary: group.subsidiary.name || 'Unknown',
                typeLesson: group.type_class?.name || 'Unknown',
                isOnline: group.is_online ? 'SI' : 'NO' || 'Unknown',
                promotion: group.promotion?.code || 'No tiene promocion',
                date: {
                    start: group.date?.start || 'No especificado',
                    end: group.date?.end || 'No especificado'
                },
                dateStart: group.date?.start
                    ? dateFormatDDMMAAAA(group.date.start)
                    : "No especificado",
                dateEnd: group.date?.end ? dateFormatDDMMAAAA(group.date.end)
                    : "No especificado",
                observation: group.observation || '',
                receptionist_in_charge: group.teacher.receptionist_in_charge


            })
        },
        // Similar configuration for 'book' sorting
        book: {
            header: 'Book',
            columns: [
                { header: "ID Grupo", accessor: "id_group", className: "tableCtype2 td" },
                { header: "Horario", accessor: "schedule", className: "tableCtype5 td" },
                { header: "Fecha de inicio", accessor: "dateStart", className: "tableCtype2 td" },
                { header: "Fecha de finalizacion", accessor: "dateEnd", className: "tableCtype2 td" },
                { header: "Maestro", accessor: "teacher", className: "tableCtype5 td" },
                { header: "Unidad", accessor: "unit", className: "tableCtype2 td" },
                { header: "Estudiantes", accessor: "students_qty", className: "tableCtype1 td" },
                { header: "Salón", accessor: "classroom", className: "tableCtype2 td" },
                { header: "Plantel", accessor: "subsidiary", className: "tableCtype2 td" },
                { header: "Tipo de clase", accessor: "typeLesson", className: "tableCtype4 td" },
                { header: "Online", accessor: "isOnline", className: "tableCtype1 td" },
                { header: "Promoción", accessor: "promotion", className: "tableCtype3 td" },
            ],
            sectionContent: (book) => (
                <div className='section-content'>
                    <h1>{book.book}</h1>
                </div>
            ),
            dataAccessor: (group) => (
                {
                    id_group: group.id,
                    id_filter: group.level.id,
                    book: group.level.name || 'Horario Disponible',
                    schedule: group?.full_dayclass ? formatFullDayClass(group.full_dayclass) : 'Unknown',
                    classroom: group.classroom?.name || 'No especificado',
                    teacher: group.teacher.name || 'Maestro no asignado',
                    unit: group.level?.unitName
                        ? group.level.unitPart
                            ? `${group.level.unitName} ${group.level.unitPart}`
                            : group.level.unitName
                        : 'Horario',
                    students_qty: `${group.students_qty || '0'}/${group.classroom?.capacity || 'Salon no especificado'}` || `0/${group.classroom?.capacity || 'Salon no especificado'}`,
                    subsidiary: group.subsidiary.name || 'Unknown',
                    typeLesson: group.type_class?.name || 'Unknown',
                    isOnline: group.is_online ? 'SI' : 'NO' || 'Unknown',
                    promotion: group.promotion?.code || 'No tiene promocion',
                    date: {
                        start: group.date?.start || 'No especificado',
                        end: group.date?.end || 'No especificado'
                    },
                    dateStart: group.date?.start
                        ? dateFormatDDMMAAAA(group.date.start)
                        : "No especificado",
                    dateEnd: group.date?.end ? dateFormatDDMMAAAA(group.date.end)
                        : "No especificado",
                    observation: group.observation || ''

                }
            )
        },
        // Similar configuration for 'schedule' sorting
        schedule: {
            header: 'Schedule',
            columns: [
                { header: "ID Grupo", accessor: "id_group", className: "tableCtype2 td" },
                { header: "Maestro", accessor: "teacher", className: "tableCtype5 td" },
                { header: "Fecha de inicio", accessor: "dateStart", className: "tableCtype2 td" },
                { header: "Fecha de finalizacion", accessor: "dateEnd", className: "tableCtype2 td" },
                { header: "Nivel", accessor: "book", className: "tableCtype2 td" },
                { header: "Unidad", accessor: "unit", className: "tableCtype2 td" },
                { header: "Estudiantes", accessor: "students_qty", className: "tableCtype1 td" },
                { header: "Salón", accessor: "classroom", className: "tableCtype2 td" },
                { header: "Plantel", accessor: "subsidiary", className: "tableCtype2 td" },
                { header: "Tipo de clase", accessor: "typeLesson", className: "tableCtype4 td" },
                { header: "Online", accessor: "isOnline", className: "tableCtype1 td" },
                { header: "Promoción", accessor: "promotion", className: "tableCtype3 td" },


            ],
            sectionContent: (schedule) => (
                <div className='section-content'>
                    <h1>{schedule.schedule || 'Unknown'}</h1>
                </div>
            ),
            dataAccessor: (group) => ({
                id_group: group.id,
                id_filter: formatFullDayClass(group?.full_dayclass) || '',
                schedule: group?.full_dayclass ? formatFullDayClass(group.full_dayclass) : 'Unknown',
                classroom: group.classroom?.name || 'No especificado',
                teacher: group.teacher?.name || 'Maestro no asignado',
                book: group.level?.name || 'HORARIO ',
                unit: group.level?.unitName
                    ? group.level.unitPart
                        ? `${group.level.unitName} ${group.level.unitPart}`
                        : group.level.unitName
                    : 'DISPONIBLE',
                students_qty: `${group.students_qty || '0'}/${group.classroom?.capacity || 'Salon no especificado'}` || `0/${group.classroom?.capacity || 'Salon no especificado'}`,
                subsidiary: group.subsidiary?.name || 'Unknown',
                class_day: group.class_day || { name: '' },
                time: group.time || { start: '00:00', end: '00:00' },
                typeLesson: group.type_class?.name || 'Unknown',
                isOnline: group.is_online ? 'SI' : 'NO' || 'Unknown',
                promotion: group.promotion?.code || 'No tiene promocion',
                date: {
                    start: group.date?.start || 'No especificado',
                    end: group.date?.end || 'No especificado'
                },
                dateStart: group.date?.start
                    ? dateFormatDDMMAAAA(group.date.start)
                    : "No especificado",
                dateEnd: group.date?.end ? dateFormatDDMMAAAA(group.date.end)
                    : "No especificado",
                observation: group.observation || ''

            })
        },
        typeLesson: {
            header: 'TypeLesson',
            columns: [
                { header: "ID Grupo", accessor: "id_group", className: "tableCtype2 td" },
                { header: "Maestro", accessor: "teacher", className: "tableCtype5 td" },
                { header: "Fecha de inicio", accessor: "dateStart", className: "tableCtype2 td" },
                { header: "Fecha de finalizacion", accessor: "dateEnd", className: "tableCtype2 td" },
                { header: "Horario", accessor: "schedule", className: "tableCtype5 td" },
                { header: "Nivel", accessor: "book", className: "tableCtype2 td" },
                { header: "Unidad", accessor: "unit", className: "tableCtype2 td" },
                { header: "Estudiantes", accessor: "students_qty", className: "tableCtype1 td" },
                { header: "Salón", accessor: "classroom", className: "tableCtype2 td" },
                { header: "Plantel", accessor: "subsidiary", className: "tableCtype2 td" },
                { header: "Tipo de clase", accessor: "typeLesson", className: "tableCtype4 td" },
                { header: "Online", accessor: "isOnline", className: "tableCtype1 td" },
                { header: "Promoción", accessor: "promotion", className: "tableCtype3 td" },

            ],
            sectionContent: (typeLesson) => (
                <div className='section-content'>
                    <h1>{typeLesson.typeLesson || 'Unknown'}</h1>
                </div>
            ),
            dataAccessor: (group) => ({
                id_group: group.id,
                id: group.type_class?.name || '',
                id_filter: group.type_class?.name || '',
                schedule: group?.full_dayclass ? formatFullDayClass(group.full_dayclass) : 'Unknown',
                classroom: group.classroom?.name || 'No especificado',
                teacher: group.teacher?.name || 'Maestro no asignado',
                book: group.level?.name || 'Unknown',
                unit: group.level?.unitName
                    ? group.level.unitPart
                        ? `${group.level.unitName} ${group.level.unitPart}`
                        : group.level.unitName
                    : 'Unknown',
                students_qty: `${group.students_qty || '0'}/${group.classroom?.capacity || 'Salon no especificado'}` || `0/${group.classroom?.capacity || 'Salon no especificado'}`,
                subsidiary: group.subsidiary?.name || 'Unknown',
                class_day: group.class_day || { name: '' },
                time: group.time || { start: '00:00', end: '00:00' },
                typeLesson: group.type_class?.name || 'Unknown',
                isOnline: group.is_online ? 'SI' : 'NO' || 'Unknown',
                promotion: group.promotion?.code || 'No tiene promocion',
                date: {
                    start: group.date?.start || 'No especificado',
                    end: group.date?.end || 'No especificado'
                },
                dateStart: group.date?.start
                    ? dateFormatDDMMAAAA(group.date.start)
                    : "No especificado",
                dateEnd: group.date?.end ? dateFormatDDMMAAAA(group.date.end)
                    : "No especificado",
                observation: group.observation || ''

            })
        }
    };

    // 🔹 Convierte "HH:mm" a formato 12h con AM/PM
    const formatTime12h = (time24) => {
        if (!time24) return "";
        const [hours, minutes] = time24.split(":").map(Number);
        const ampm = hours >= 12 ? "PM" : "AM";
        const hours12 = hours % 12 || 12;
        return `${hours12}:${minutes.toString().padStart(2, "0")} ${ampm}`;
    };

    // 🔹 Convierte un full_dayclass completo
    const formatFullDayClass = (fullDayClass) => {
        if (!fullDayClass) return "Unknown";

        // Busca la parte de horas al final (ejemplo: "18:00-19:00")
        const match = fullDayClass.match(/(\d{2}:\d{2})-(\d{2}:\d{2})$/);

        if (!match) {
            // Si no encuentra horas, devuelve tal cual
            return fullDayClass;
        }

        const [_, start, end] = match;
        const formattedTime = `${formatTime12h(start)} - ${formatTime12h(end)}`;

        // Reemplaza solo la parte de las horas
        return fullDayClass.replace(match[0], formattedTime);
    };

    // Handle sort change when user selects a different criteria
    const handleSortChange = (value) => {
        if (value) {  // Ensure 'value' is not undefined
            setSortCriteria(value);
        }
    };

    const handleSortSubsidiaryChange = (value) => {
        if (value) {
            setSortSubsidiaryCriteria(value);
            applyFilters(value, sortStatusCriteria, selectedModality);
        }
    };

    const handleSortStatusChange = (value) => {
        if (value) {
            setSortStatusCriteria(value);
            applyFilters(sortSubsidiaryCriteria, value, selectedModality);
        }
    };

    const handleSortModalityChange = (value) => {
        if (value) {
            setSelectedModality(value);
            applyFilters(sortSubsidiaryCriteria, sortStatusCriteria, value);
        }
    };

    const applyFilters = (subsidiaryValue, statusValue, selectedModality) => {
        let filtrados = arrayTeacherClasses;
        // Filtrar por Sucursal
        if (subsidiaryValue) {
            filtrados = filtrados.filter(grupo => grupo.subsidiary.id === parseInt(subsidiaryValue));
        }

        // Filtrar por Estatus
        if (statusValue) {
            const statusNumber = parseInt(statusValue);
            filtrados = filtrados.filter(grupo => {
                if (statusNumber === 1) return grupo.is_finished === 0 && grupo.st === 0; // En curso
                if (statusNumber === 2) return grupo.is_finished === 0 && grupo.st === 0 && new Date(grupo.date.start) > getLocalDateObject(); // En curso
                if (statusNumber === 3) return grupo.is_finished === 1; // Finalizado
                if (statusNumber === 4) return grupo.st === 1; // Eliminado
                return true; // Si no coincide, no se filtra
            });
        }

        if (selectedModality) {
            const modalityFilter = parseInt(selectedModality)
            filtrados = filtrados.filter(grupo => {
                if (modalityFilter === 2) return grupo.is_online === null || grupo.is_online === 0
                if (modalityFilter === 3) return grupo.is_online === 1
                return true
            })

        }

        setFilteredArrayTeacherClass(filtrados);
    };
    // Assign a CSS class based on the book level for row styling
    const getBookClass = (fila) => {
        const bookColor = fila.book || '';
        const isOnline = fila.isOnline || 'NO';
        if (isOnline === 'SI' && parseInt(selectedModality) !== 3) {
            return 'isOnline'
        } else {
            switch (bookColor) {
                case "Nivel 1": return new Date(fila.date?.start) > getLocalDateObject() ? "level1book shiny-row" : "level1book";
                case "Nivel 2": return "level2book";
                case "Nivel 3": return "level3book";
                case "Nivel 4": return "level4book";
                case "Nivel 5": return "level5book";
                case "Smile 1": return new Date(fila.date?.start) > getLocalDateObject() ? "k1book shiny-row" : "k1book";
                case "Smile 2": return "k2book";
                case "Smile 3": return "k3book";
                case "Smile 4": return "k4book";
                case "Smile 5": return "k5book";
                case "Smile 6": return "k6book";
                case "Mega": return "k7book";
                default: return "available-schedule";

            }
        }
    };

    const getObservationClasses = (row) => {
        const observations = row
        return observations.observation || ''
    }

    // Group data based on the selected criteria
    const groupByCriteria = (data) => {
        const groupedData = data.reduce((acc, item) => {
            const key = item.id_filter; // Group by id
            if (!acc[key]) {
                acc[key] = { key, items: [] };
            }
            acc[key].items.push(item); // Add all related items to this id
            return acc;
        }, {});

        // Return grouped data
        return Object.keys(groupedData).map(key => ({
            key,
            items: groupedData[key].items // Pass the complete array here
        }));
    };


    const processGroups = () => {
        // Step 1: Map through GROUPS array and apply the dataAccessor based on the selected sorting criteria
        const data = filteredArrayTeacherClasses.map(group => criteriaOptions[sortCriteria].dataAccessor(group));
        // Step 2: Sort the data based on the schedule using the sortBySchedule function
        const sortedData = sortBySchedule(data);
        // Step 3: Group the sorted data by the selected criteria using groupByCriteria
        return groupByCriteria(sortedData);
    };

    // Hacer pruebas para quiatr la funcion comentada
    // const sortBySchedule = (data) => {
    //     // Check if the input is an array, handle error if not
    //     if (!Array.isArray(data)) {
    //         console.error('Data is not an array:', data);
    //         return []; // Return an empty array if there is an error
    //     }

    //     // Define the order of days for sorting
    //     const dayOrder = {
    //         "Lunes - Viernes": 1,
    //         "Sabado": 2,
    //         "Domingo": 3
    //     };

    //     // Helper function to convert time string (e.g., "14:30") to minutes
    //     const parseTime = (timeStr) => {
    //         const [hours, minutes] = timeStr.split(':').map(Number);
    //         return hours * 60 + minutes;
    //     };

    //     // Helper function to clean the day name (removes ' AM' or ' PM')
    //     const cleanDayName = (day) => {
    //         return day.replace(/\s+(AM|PM)/, ''); // Remove ' AM' or ' PM'
    //     };

    //     // Function to compare days based on the predefined order
    //     const compareDays = (aDay, bDay) => {
    //         const aValue = dayOrder[cleanDayName(aDay.trim())] || Infinity; // Assign Infinity if day is not found
    //         const bValue = dayOrder[cleanDayName(bDay.trim())] || Infinity;
    //         return aValue - bValue;
    //     };

    //     // Main sorting function: sort by day, then by start time, then by end time
    //     return data.sort((a, b) => {
    //         const aDay = a.class_day?.name || ''; // Get the day of class A
    //         const bDay = b.class_day?.name || ''; // Get the day of class B
    //         const aTimeStart = a.time?.start || '00:00'; // Get the start time of class A
    //         const bTimeStart = b.time?.start || '00:00'; // Get the start time of class B
    //         const aTimeEnd = a.time?.end || '00:00'; // Get the end time of class A
    //         const bTimeEnd = b.time?.end || '00:00'; // Get the end time of class B

    //         // First, compare by day (after cleaning the day name)
    //         const dayComparison = compareDays(aDay, bDay);
    //         if (dayComparison !== 0) {
    //             return dayComparison; // If days are different, return the comparison result
    //         }

    //         // If days are the same, compare by start time
    //         const timeComparison = parseTime(aTimeStart) - parseTime(bTimeStart);
    //         if (timeComparison !== 0) {
    //             return timeComparison; // If start times are different, return the comparison result
    //         }

    //         // If start times are the same, compare by end time
    //         return parseTime(aTimeEnd) - parseTime(bTimeEnd);
    //     });
    // };
    //-------------------------------------------------------------------------------------------------------
    const sortBySchedule = (data) => {
        if (!Array.isArray(data)) return [];

        // Orden de días
        const dayOrder = {
            "Lunes": 1,
            "Martes": 2,
            "Miércoles": 3,
            "Jueves": 4,
            "Viernes": 5,
            "Sábado": 6,
            "Domingo": 7
        };

        // Convierte "h:mm AM/PM" a minutos
        const parseTime12h = (timeStr) => {
            if (!timeStr) return 0;
            const [time, ampm] = timeStr.trim().split(" ");
            let [hours, minutes] = time.split(":").map(Number);
            if (ampm.toUpperCase() === "PM" && hours !== 12) hours += 12;
            if (ampm.toUpperCase() === "AM" && hours === 12) hours = 0;
            return hours * 60 + minutes;
        };

        // Extrae día y horas de un schedule string
        const parseSchedule = (schedule) => {
            // Ejemplo: "Lunes, Martes, Miércoles 6:00 PM - 7:00 PM"
            const match = schedule.match(/(.+?)\s+(\d{1,2}:\d{2}\s[APM]{2})\s-\s(\d{1,2}:\d{2}\s[APM]{2})$/);

            if (!match) {
                return { day: "Unknown", dayValue: 99, start: 0, end: 0 };
            }

            const daysPart = match[1]; // "Lunes, Martes, Miércoles"
            const start = match[2];    // "6:00 PM"
            const end = match[3];      // "7:00 PM"

            const firstDay = daysPart.split(",")[0].trim();

            return {
                day: firstDay,
                dayValue: dayOrder[firstDay] || 99,
                start: parseTime12h(start),
                end: parseTime12h(end)
            };
        };

        return data.sort((a, b) => {
            const aParsed = parseSchedule(a.schedule);
            const bParsed = parseSchedule(b.schedule);

            if (aParsed.dayValue !== bParsed.dayValue) {
                return aParsed.dayValue - bParsed.dayValue;
            }
            if (aParsed.start !== bParsed.start) {
                return aParsed.start - bParsed.start;
            }
            return aParsed.end - bParsed.end;
        });
    };


    const handleCloseModalEditTeacherGroup = () => {
        setOpenModalEditTeacher(false)
    }
    const handleRowClick = (selectedRow) => {
        const idGroup = selectedRow.id_group;
        const selectedItem = filteredArrayTeacherClasses.find(item => item.id === idGroup);
        if (Object.keys(selectedItem).length !== 0) {
            if (user.idPriv === parseInt(process.env.REACT_APP_API_SUPERADMIN_PRIVILEGE)) {
                setSelectedItemRow(selectedItem)
                setOpenModalEditTeacher(true)
            } else {
                if (user.fk_subsidiary === selectedItem.subsidiary.id) {
                    setSelectedItemRow(selectedItem)
                    setOpenModalEditTeacher(true)
                } else {
                    showAlert('danger', 'Lo sentimos, no puede hacer edición de un grupo que no pertenezca a su sucursal')
                }
            }
        }
    };

    const handleUpdateUnit = async () => {
        let subsidiaryToUpdate = user.fk_subsidiary
        if (user.idPriv === parseInt(process.env.REACT_APP_API_SUPERADMIN_PRIVILEGE)) {
            subsidiaryToUpdate = sortSubsidiaryCriteria
        }
        const checkClassesUnits = await GetUnitLimitsGroup(subsidiaryToUpdate)
        setModalConfirmTitle('Actualizar unidad de grupos')
        setModalConfirmDescription(checkClassesUnits.message)
        setOpenConfirmUpdateUnit(true)
    }

    const handleCloseConfirmUpdateUnit = () => {
        setOpenConfirmUpdateUnit(false)
    }

    const handleConfirmUpdateUnit = async () => {
        setDisabledButtonConfirmModal(true)
        let subsidiaryToUpdate = user.fk_subsidiary
        if (user.idPriv === parseInt(process.env.REACT_APP_API_SUPERADMIN_PRIVILEGE)) {
            subsidiaryToUpdate = sortSubsidiaryCriteria
        }
        const editUnit = await EditUnitTeacherClasses(subsidiaryToUpdate)
        if (editUnit.status === 200) {
            if (editUnit.teacher_classes_updated.arrayClassesUpdated.length !== 0) {
                // Borrar la caché solo de esa subsidiaria (opcional)
                delete cacheGroupList.current[sortSubsidiaryCriteria];
                showAlert('success', editUnit.teacher_classes_updated.message)
                await fetchTeacherClassData(true)

                setTimeout(() => {
                    setOpenConfirmUpdateUnit(false)
                    setDisabledButtonConfirmModal(false)

                }, 3500);
            }
        } else {
            setDisabledButtonConfirmModal(false)
        }
    }
    return (
        <>
            <div className='principal-list-groups-modal-teacher-class main-color'>
                <div className="manual-update-unit">
                    <Tooltip text={'Recomendamos que si tiene un grupo el cual quiera hacer un repaso edite su unidad manualmente'}>
                        <Button text={'Actualizar unidad'} onClick={handleUpdateUnit} />
                    </Tooltip>
                </div>
                <section className='list-groups-header'>
                    <div className='header-title'>
                        <h1>Listado de grupos</h1>
                        <div className='order-close'>
                            <div className='order-select'>
                                <label>Modalidad</label>
                                <Select
                                    options={modalityOptions}
                                    placeholder="Ordenar por..."
                                    onChange={(e) => handleSortModalityChange(e.target.value)}
                                    classN="main-color"
                                    value={selectedModality}
                                />
                            </div>
                            <div className='order-select'>
                                <label>Estatus</label>
                                <Select
                                    options={selectOptionsStatus}
                                    placeholder="Ordenar por..."
                                    onChange={(e) => handleSortStatusChange(e.target.value)}
                                    classN="main-color"
                                    value={sortStatusCriteria}
                                />
                            </div>
                            <div className='order-select'>
                                <label>Sucursal</label>
                                <Select
                                    options={subsidiaryList}
                                    placeholder="Ordenar por..."
                                    onChange={(e) => handleSortSubsidiaryChange(e.target.value)}
                                    classN="main-color"
                                    value={sortSubsidiaryCriteria}
                                />
                            </div>
                            <div className='order-select'>
                                <label>Orden</label>
                                <Select
                                    options={selectOptions}
                                    placeholder="Ordenar por..."
                                    onChange={(e) => handleSortChange(e.target.value)}
                                    classN="main-color"
                                    value={sortCriteria}
                                />
                            </div>

                        </div>
                    </div>

                </section>
                {processGroups().map(group => (

                    <section key={group.key} className='classroom-contain'>
                        {criteriaOptions[sortCriteria].sectionContent(group.items[0])} {/* Mostramos solo la información de uno de los ítems */}
                        <TableCstm
                            columns={criteriaOptions[sortCriteria].columns}
                            data={group.items}
                            getRowClass={getBookClass}
                            onRowClick={handleRowClick} // Pasamos la función
                            getRowObservation={getObservationClasses}
                            positionTooltip={'left'}

                        />
                    </section>
                ))}
            </div>
            <ModalEditTeacherClass
                open={openModalEditTeacher}
                onCloseButton={handleCloseModalEditTeacherGroup}
                editData={selectedItemRow}
                usr={user}
                showAlert={showAlert}
                fetchTeacherClassData={fetchTeacherClassData}
            />
            <ConfirmModal
                isOpen={openConfirmUpdateUnit}
                handleCancel={handleCloseConfirmUpdateUnit}
                handleAccept={handleConfirmUpdateUnit}
                title={modalConfirmTitle}
                text={modalConfirmDescription}
                disabled={disabledButtonConfirmModal}
            />
        </>
    );
};
export default GroupsList
